module.exports = __webpack_public_path__ + "img/kuhn-s-intellectual-path-cover.aa7cd0c7.jpg";